import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=0c8f8d24&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"
import style0 from "./PanelCard.vue?vue&type=style&index=0&id=0c8f8d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f8d24",
  null
  
)

export default component.exports